"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cross = _interopRequireDefault(require("@dcl/icons/lib/ui/cross"));

var _Heading = _interopRequireWildcard(require("../../elements/Heading"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

var _isOpenContext = require("./isOpenContext");

var _types = require("../../core/types");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getFocusableDescendants = function getFocusableDescendants(node) {
  /*
   * this is based on the code provided by:
   * https://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/dialog.html
   * at `aria.Utils.isFocusable`
   */
  var selector = ["button:not([disabled])", "[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "[tabindex]:not([tabindex='-1'])"].join(", ");
  return node.querySelectorAll(selector);
};

var getModalRoot = function getModalRoot() {
  var modalRootId = "modalRoot";
  var modalRoot = document.getElementById(modalRootId);

  if (!modalRoot) {
    var newElement = document.createElement("div");
    newElement.id = modalRootId;
    document.body.appendChild(newElement);
    return newElement;
  }

  return modalRoot;
};

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", (0, _classNames["default"])(Modal.displayName));

    _defineProperty(_assertThisInitialized(_this), "titleRef", /*#__PURE__*/_react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "contentRef", /*#__PURE__*/_react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "dialogRef", /*#__PURE__*/_react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "closeRef", /*#__PURE__*/_react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "appRoot", document.getElementById(_this.props.appRootId || "root"));

    _defineProperty(_assertThisInitialized(_this), "modalRoot", getModalRoot());

    _defineProperty(_assertThisInitialized(_this), "el", document.createElement("div"));

    _defineProperty(_assertThisInitialized(_this), "lastScrollRatio", void 0);

    _defineProperty(_assertThisInitialized(_this), "lastFocusEl", void 0);

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _defineProperty(_assertThisInitialized(_this), "activeElementBeforeOpenModal", document.activeElement);

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (event) {
      if (event) {
        event.stopPropagation();
      }

      _this.props.closeThisComponent();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (event) {
      /** TODO: these should be provided by another module/typings file, enum or const object yet to be determined */
      var ESCAPE_KEY_CODE = 27;
      var ESCAPE = "escape"; // event.keyCode is deprecated, we should use event.key

      if (event.keyCode === ESCAPE_KEY_CODE || event.key === ESCAPE) {
        _this.handleClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOverlayClick", function (event) {
      // close if target element is the overlay, not the dialog
      if (event.target === _this.ref.current) {
        _this.handleClose(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if (!_this.dialogRef.current) {
        return;
      }

      var isTargetWithinModal = _this.dialogRef.current.contains(event.target);

      if (isTargetWithinModal) {
        _this.lastFocusEl = {
          current: event.target
        };
        return;
      }

      var focusableDialogDescendants = getFocusableDescendants(_this.dialogRef.current);

      if (!focusableDialogDescendants.length && _this.contentRef.current) {
        _this.contentRef.current.focus();

        return;
      }

      if (_this.lastFocusEl.current === focusableDialogDescendants[0]) {
        focusableDialogDescendants[focusableDialogDescendants.length - 1].focus();
      } else {
        focusableDialogDescendants[0].focus();
      }

      _this.lastFocusEl = {
        current: document.activeElement
      };
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props;

      /*
       * The portal element is inserted in the DOM tree after
       * the Modal's children are mounted, meaning that children
       * will be mounted on a detached DOM node. If a child
       * component requires to be attached to the DOM tree
       * immediately when mounted, for example to measure a
       * DOM node, or uses 'autoFocus' in a descendant, add
       * state to Modal and only render the children when Modal
       * is inserted in the DOM tree.
       */
      this.modalRoot.appendChild(this.el);
      /**
       * hide all other page content from screen readers
       * https://www.w3.org/TR/wai-aria-1.0/states_and_properties#aria-hidden
       */

      this.appRoot.setAttribute("aria-hidden", "true");
      var scrollTop = window.scrollY || window.pageYOffset || 0;
      this.lastScrollRatio = scrollTop / document.body.scrollHeight;

      if (!((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.disableScrollLocked)) {
        document.body.classList.add("is-scrollLocked");
      }

      document.addEventListener("focus", this.handleFocus, true);

      if (!this.props.uncloseable) {
        document.addEventListener("keydown", this.handleKeydown, false);
      }

      this.lastFocusEl = this.contentRef;

      if (this.contentRef.current) {
        this.contentRef.current.focus();
      } // According to the accessibility standarts, when Modal is open, the title should be focused by default
      // if (this.titleRef.current && !this.props.isCloseButtonHidden) {


      if (this.titleRef.current && !this.props.isCloseButtonHidden) {
        this.titleRef.current.focus();
      } // close all other modals, and add this instance to the list


      Modal.mountedModals.forEach(function (modal) {
        return modal.handleClose();
      });
      Modal.mountedModals.push(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      this.modalRoot.removeChild(this.el);
      this.appRoot.removeAttribute("aria-hidden");
      document.body.classList.remove("is-scrollLocked");
      document.removeEventListener("focus", this.handleFocus, true);

      if (!this.props.uncloseable) {
        document.removeEventListener("keydown", this.handleKeydown, false);
      }

      var scrollTop = this.lastScrollRatio * document.body.scrollHeight;
      window.scroll(0, scrollTop); // remove this instance from the list of mounted modals

      Modal.mountedModals = Modal.mountedModals.filter(function (modalInstance) {
        return modalInstance !== _this2;
      }); // Return focus to the last active element before the Modal was opened

      if (this.activeElementBeforeOpenModal) {
        this.activeElementBeforeOpenModal.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      /*
       * Bracket the dialog node with two invisible, focusable nodes.
       * While this dialog is open, we use these to make sure that focus never
       * leaves the document even if dialogNode is the first or last node.
       *
       * following example of:
       * https://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/dialog.html
       * see: `aria.Dialog` constructor
       */
      var a11yPropsContainer = {};

      if (this.props.ariaLabel && !this.props.headerId) {
        a11yPropsContainer = {
          "aria-label": this.props.ariaLabel
        };
      } else if (this.props.headerId) {
        a11yPropsContainer = {
          "aria-labelledby": this.props.headerId
        };
      }

      var a11yPropsCloseButton = {};

      if (this.props.closeButtonAriaLabel) {
        a11yPropsCloseButton["aria-label"] = this.props.closeButtonAriaLabel;
      }

      if (this.props.headerId) {
        a11yPropsCloseButton["aria-describedby"] = this.props.headerId;
      }

      return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_isOpenContext.Provider, {
        value: true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.getClassName(), this.props.className) // eslint-disable-next-line
        ,
        onClick: this.props.uncloseable ? undefined : this.handleOverlayClick,
        ref: function ref(_ref) {
          if (_ref) {
            _this3.ref = {
              current: _ref
            };
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("div", _extends({}, a11yPropsContainer, {
        "aria-modal": true,
        className: (0, _classnames["default"])(this.getClassName({
          descendantName: "dialog",
          modifiers: this.props.animation
        })),
        role: "dialog",
        ref: this.dialogRef
      }), !this.props.uncloseable && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "header"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "headerOuter"
        })
      }, this.props.headerTitle && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "headerTitle"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "headerTitleCenter"
        }),
        ref: this.titleRef,
        tabIndex: -1
      }, /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
        id: "Title",
        type: _Heading.types.Small,
        rank: _types.Rank.Second
      }, /*#__PURE__*/_react["default"].createElement("strong", null, this.props.headerTitle)))), !this.props.isCloseButtonHidden && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "headerInner"
        })
      }, /*#__PURE__*/_react["default"].createElement("button", _extends({}, a11yPropsCloseButton, {
        className: this.getClassName({
          descendantName: "button"
        }),
        onClick: this.handleClose,
        ref: this.closeRef,
        "aria-label": "Close dialog"
      }), this.props.closeLabel && /*#__PURE__*/_react["default"].createElement("span", {
        className: this.getClassName({
          descendantName: "buttonLabel",
          utilities: "typographySmallCaps"
        })
      }, this.props.closeLabel), /*#__PURE__*/_react["default"].createElement("span", {
        className: this.getClassName({
          descendantName: "buttonCross"
        })
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "content"
        }),
        ref: this.contentRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "contentOuter"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "contentInner"
        })
      }, this.props.children)))), /*#__PURE__*/_react["default"].createElement("div", {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0
      }))), this.el);
    }
  }]);

  return Modal;
}(_react["default"].Component);

_defineProperty(Modal, "displayName", "Modal");

_defineProperty(Modal, "mountedModals", []);

var _default = Modal;
exports["default"] = _default;